
































import VueOptions from '@utils/VueOptions'
import LoadingIndicator from '@/components/LoadingIndicator'
import WelcomeModal from './WelcomeModal'

settings =
  name: 'Navbar'

  vue:
    components: { LoadingIndicator, WelcomeModal }

    data: ->
      selectedSegment: null

    computed:
      brandRep: -> @partnerBuy().brandRep
      campaignId: -> @$route.params?.campaignId

      audiencePartnershipLogo: ->
        { audience_partnership } = @partnerBuy()
        audience_partnership?.logo || audience_partnership?.supplier?.logo

      audiencePartnershipName: ->
        { audience_partnership } = @partnerBuy()
        audience_partnership?.supplier?.name

    mounted: ->
      @selectedSegment = @$route.query.segment if @$route.query.segment

    methods:
      hiCancel: ->
        path = @lookupListingPath()
        @logout { path }

      partnerBuy: -> @getAppSession('partnerBuy', {})

      lookupListingPath: ->
        { bookings, token } = @partnerBuy()
        listingId = Object.keys(bookings)?[0]
        segment = Object.values(Object.values(bookings)?[0]?.spaces)[0].segment
        path = "/buy/listings/#{listingId}?buy_partnership=#{token}&segment=#{segment}" if listingId

    watch:
      '$route.query.show_welcome_modal': ->
        { show_welcome_modal, ...query } = @$route.query
        return unless show_welcome_modal
        @$refs.welcomeModal.show()
        @$router.replace { query }

export default VueOptions.vue settings
